import { PrizeTypes } from "../brandVariables.types";

export const elgigantenPrize: PrizeTypes = {
  content: "Set a lap time and win",
  nameOf: "Dreamhack", // will be marked in color
  typeOfItem: "coins", // will be added after nameOf
};
